/* eslint-disable */

import axios from "axios";
require("../../config/development");
import Vue from "vue";

const state = {
  token: null,
  admin: null,
  succesFlag: false,
  showNotification: false,
  notificationMessage: null
};

// actions
const actions = {
  adminLogIn(context, payload) {
    return Vue.vueAuth
      .authenticate(payload.provider, {})
      .then(response => {
        context.commit("SET_TOKEN", response.data);
        context.dispatch("fetchAdminInfo", payload.route);
      })
      .catch(err =>
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: err.message,
          succesFlag: false
        })
      );
  },
  adminLogout(context) {
    Vue.vueAuth.logout();
    context.commit("REMOVE_TOKEN");
    return Promise.resolve(true);
  },
  fetchAdminInfo(context, route) {
    axios
      .get(
        `${Vue.config.EL_DORADO_API_URL}/admin/adfes433fkdfggs343434/admin.json`
      )
      .then(response => context.commit("SAVE_ADMIN_DETAILS", response.data))
      .catch(() => {
        Vue.vueAuth.logout();
        route.push("/");
        context.commit("SHOW_NOTIFICATION", {
          showNotification: true,
          message: "Unauthorized user",
          succesFlag: false
        });
      });
  }
};

// mutations
const mutations = {
  ["SET_TOKEN"](state, payload) {
    state.token = payload;
  },
  ["REMOVE_TOKEN"](state) {
    state.token = null;
    state.admin = null;
  },
  ["SAVE_ADMIN_DETAILS"](state, payload) {
    state.admin = payload;
  },
  ["SHOW_NOTIFICATION"](state, payload) {
    state.showNotification = payload.showNotification;
    state.notificationMessage = payload.message;
    state.succesFlag = payload.succesFlag;
  }
};

export default {
  state,
  actions,
  mutations
};
